import request from '@/utils/request'

const api = {
  signup: 'user/signup',
  signin: 'user/signin',
  getUserInfo: 'user/getUserInfo',
  getUserStarList: 'user/getUserStarList',
  getUserVideoList: 'user/getUserVideoList',
  getUserHistoryList: 'user/getUserHistoryList',
  getUserAuth: 'user/getUserAuth',
  saveAuth: 'user/saveAuth',
  updatePwd: 'user/updatePwd',
  updateTradePwd: 'user/updateTradePwd',
  touristSignin: 'user/touristSignin',
  update: 'user/update'
}
export default {
  signup(parameter) {
    return request({
      url: api.signup,
      method: 'POST',
      data: parameter
    })
  },
  update(parameter) {
    return request({
      url: api.update,
      method: 'POST',
      data: parameter
    })
  },
  signin(parameter) {
    return request({
      url: api.signin,
      method: 'POST',
      data: parameter
    })
  },
  touristSignin(parameter) {
    return request({
      url: api.touristSignin,
      method: 'POST',
      data: parameter
    })
  },
  getUserInfo(parameter) {
    return request({
      url: api.getUserInfo,
      method: 'POST',
      data: parameter
    })
  },
  getUserAuth(parameter) {
    return request({
      url: api.getUserAuth,
      method: 'POST',
      data: parameter
    })
  },
  saveAuth(parameter) {
    return request({
      url: api.saveAuth,
      method: 'POST',
      data: parameter
    })
  },
  updatePwd(parameter) {
    return request({
      url: api.updatePwd,
      method: 'POST',
      data: parameter
    })
  },
  updateTradePwd(parameter) {
    return request({
      url: api.updateTradePwd,
      method: 'POST',
      data: parameter
    })
  },
  getUserStarList(parameter) {
    return request({
      url: api.getUserStarList,
      method: 'POST',
      data: parameter
    })
  },
  getUserVideoList(parameter) {
    return request({
      url: api.getUserVideoList,
      method: 'POST',
      data: parameter
    })
  },
  getUserHistoryList(parameter) {
    return request({
      url: api.getUserHistoryList,
      method: 'POST',
      data: parameter
    })
  }
}
